/* ==========================================================================
   TechNest — recommendations.js
   Loads Shopify's own product recommendations. The response is Liquid-rendered
   section markup, so prices and badges are never assembled in JavaScript. If
   Shopify returns no recommendations the element removes itself instead of
   leaving an empty heading behind.
   ========================================================================== */
(function () {
  'use strict';

  const TN = window.TechNest || {};
  const utils = TN.utils;
  if (!utils) return;

  class TnRecommendations extends HTMLElement {
    connectedCallback() {
      // Only fetch once the section is close to the viewport.
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this._observer.disconnect();
            this.load();
          },
          { rootMargin: '400px 0px' }
        );
        this._observer.observe(this);
      } else {
        this.load();
      }
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }

    async load() {
      const url = this.dataset.url;
      if (!url || this._loaded) return;
      this._loaded = true;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Recommendations failed: ' + response.status);
        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const fresh = parsed.querySelector('tn-recommendations');

        if (!fresh || !fresh.querySelector('.tn-grid')) {
          this.remove();
          return;
        }
        this.innerHTML = fresh.innerHTML;
        if (TN.initReveal) TN.initReveal(this);
        document.dispatchEvent(new CustomEvent('tn:section:load', { detail: { target: this } }));
      } catch (error) {
        this.remove();
      }
    }
  }

  utils.define('tn-recommendations', TnRecommendations);
})();
